import React from 'react';
import bugsnag from '@bugsnag/js';
import bugsnagReact from '@bugsnag/plugin-react';
const errorHandler = () => {
  let client;
  const createClient = config => {
    client = bugsnag({
      logger: null,
      notifyReleaseStages: ['staging', 'production'],
      ...config
    });
    client.use(bugsnagReact, React);
  };
  const setUser = id => {
    client.user = {
      id
    };
  };
  const getClient = () => client;
  const getErrorBoundary = () => client.getPlugin('react');
  const report = function (error, userId) {
    let severity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'error';
    return client.notify(error, {
      user: {
        id: userId
      },
      severity
    });
  };
  return {
    createClient,
    setUser,
    getClient,
    getErrorBoundary,
    report
  };
};
var errorHandler$1 = errorHandler();
class BaseError extends Error {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }
  }
}
class ApiError extends BaseError {}
class ApiActionFailedError extends BaseError {
  constructor(message, data) {
    super(message);
    this.data = data;
  }
}
class ApiAuthError extends BaseError {}
class ApiAvailabilityError extends BaseError {
  constructor(message, data) {
    super(message);
    this.data = data;
  }
}
class ApiInvalidRequestError extends BaseError {}
class ApiNotFoundError extends BaseError {}
class ApiValidationError extends BaseError {
  constructor(message, data) {
    super(message);
    this.data = data;
  }
}
class ApplicationError extends BaseError {}
export { ApiActionFailedError, ApiAuthError, ApiAvailabilityError, ApiError, ApiInvalidRequestError, ApiNotFoundError, ApiValidationError, ApplicationError, BaseError, errorHandler$1 as errorHandler };